export default function DesignedForSmarterDeployment() {
  const deploymentCards = [
    {
      icon: 'ri-tools-line',
      title: 'Reduced On-site Disruption',
      description: 'Prefabricated components are manufactured and assembled off site. This approach is designed to help reduce on-site construction time, noise and material waste — subject to site conditions and local requirements.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Durable Material Systems',
      description: 'Aluminium and stainless-steel material systems are selected for their strength-to-weight ratio, corrosion resistance and long service life. These materials can also be recycled at end of life, supporting more sustainable building practices.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Customisable Interiors',
      description: 'Interior layouts, finishes, lighting and fixtures can be tailored to suit a range of guest experiences and operational needs. Configuration options are discussed during the project consultation and scoping phase.'
    },
    {
      icon: 'ri-hotel-line',
      title: 'Hospitality Ready',
      description: 'Designed with hospitality operators in mind — from boutique glamping sites to private retreats. Each pod layout can be configured to support short-stay accommodation models, with consideration for guest comfort and practical operations.'
    }
  ];

  return (
    <section className="py-20 sm:py-28 lg:py-36 bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6 text-white">
            Designed for <span className="text-cyan-400">Smarter Deployment</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            The X Series is conceived to support more efficient project delivery — from material selection through to on-site assembly — while remaining adaptable to the unique requirements of each location.
          </p>
        </div>

        {/* Deployment Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12">
          {deploymentCards.map((card, index) => (
            <div
              key={index}
              className="group relative bg-black/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-500/40 hover:shadow-[0_0_30px_rgba(0,217,255,0.15)] transition-all duration-300"
            >
              <div className="w-14 h-14 bg-cyan-500/10 border border-cyan-500/30 rounded-xl flex items-center justify-center mb-6 group-hover:bg-cyan-500/20 group-hover:border-cyan-500/50 transition-all">
                <i className={`${card.icon} text-2xl text-cyan-400`}></i>
              </div>
              <h3 className="text-xl font-medium text-white mb-3">{card.title}</h3>
              <p className="text-base text-gray-400 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-cyan-500/5 border border-cyan-500/15 rounded-xl p-6 text-center">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-cyan-500/10 border border-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-lg text-cyan-400"></i>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed text-left">
                Site preparation, approvals, installation requirements and final specifications vary by location and project. Contact Nexa Pods for a site-specific assessment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}